// removed by extract-text-webpack-plugin
module.exports = {"assistent":"_33IE4llD5SVz_jyNlbdFAc","assistent__dialog":"_2HT1xt2YfL6ZA7YgoGxw9o","assistent__dialog__wave":"_2eKmN_mV7CarlWa_jnWWFb","assistent__dialog__speech":"_2hRL5FoytkEcocI0e3BnpT","assistent__dialog__overlay":"wRef-oiFkPnRjXLPeBHUN","overlay-bg":"_3eeeS7Pwc7zxlGC56mFZn0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Assistent/style.css
// module id = 330
// module chunks = 0